var $ = require('../modules/jquery');

(function () {
  // Functions
  // ---------------------------------------------------------------------------
  function displaySuggestion() {
    if ($("#search-did-you-mean").length) {
      var searchQuery = decodeURIComponent($.urlParam('search_api_fulltext'));

      $.ajax({
        type: 'POST',
        url: drupalSettings.elasticsearch_connector['url'] + "/" + drupalSettings.elasticsearch_connector['index_name'] + '/_search',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
          searchSuggest(response, searchQuery);
        },

        //we use the full rendered_item field, which is the rendered entity minus html to get terms for term suggester
        data: JSON.stringify({"suggest": {"text": searchQuery, "suggestion": {"term": {"field": "rendered_item"}}}})
      });
    }
  }

  function searchSuggest(response, searchQuery) {
    var searchQueryUrl = searchQuery;
    searchQuery = searchQuery.replace("+", " ");

    var printResults = false;
    var contentType = decodeURIComponent($.urlParam('content_type')) > 0 ? decodeURIComponent($.urlParam('content_type')) : 1;

    //reverse the suggestions so we replace terms in order from last to to first to preserve correct length and offset values
    $.each(response.suggest.suggestion.reverse(), function(element, value) {
      if(value.options.length > 0) {
        var replacement = value.options.length > 0 ? value.options[0].text : '';
        var replacementHTML = value.options.length > 0 ? "<mark>"+value.options[0].text.replace("+", " ")+"</mark>" : '';

        searchQuery = searchQuery.substr(0, value.offset) + replacementHTML + searchQuery.substr(value.offset + value.length);
        searchQueryUrl = searchQueryUrl.substr(0, value.offset) + replacement + searchQueryUrl.substr(value.offset + value.length);

        printResults = true;
      }
      else {
        searchQuery = searchQuery.replace("+", " ");
      }
    });

    if(printResults)
    {
        $("#search-did-you-mean").html(Drupal.t("Did you mean")+" <a href='"+Drupal.url("search-results?search_api_fulltext="+searchQueryUrl)+"'>"+searchQuery.replace("+", " ")+"</a>?");
        $("#search-did-you-mean").show();
    }
  }

  // Initializations
  // ---------------------------------------------------------------------------
  $.urlParam = function(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

    if(results == null) {
      return 0;
    }

    return results[1] || 0;
  };

  Drupal.behaviors.searchDidYouMean = {
    'attach': displaySuggestion(),
  }
})();



//////////////////
// WEBPACK FOOTER
// ./web/themes/contrib/nccourts-theme/assets/src/js/components/search-did-you-mean.js
// module id = 39
// module chunks = 11